const useObjectHelper = () => {

	const arrToOptionList = <T>(arr: T[]) => {
		return arr.map((item: T ) => ({ label: item, value: item }));
	}

	const cleanObj = (obj: {[key: string]: any}) => {
		return Object.getOwnPropertyNames(obj).reduce((acc: any, curr) => {
			if ( (!Array.isArray(obj[curr]) && obj[curr]) || ( Array.isArray(obj[curr]) && obj[curr][0])) {
				acc = {
					...acc,
					[curr]: obj[curr],
				}
			}
			return acc;
		}, {});
	}

	const objToOptionList = (obj: {[key: string]: any}) => {
		return Object.keys(obj).map((key, index) => ({ label: obj[key], value: key }));
	}

	const objToFormData = (obj: any) => {
		return Object.entries(obj).reduce((acc: any, curr: any) => {
			const [ key, value ] = curr;
			if (Array.isArray(value)) {
				value.map((item) => acc.append(key, `${item}`));
			} else if (value && typeof value === 'object' && !(value instanceof File)) {
				Object.keys(value).map((key2) => acc.append(`${key}.${key2}`, `${value[key2]}`))
			} else if (['number', 'boolean'].includes(typeof value)) {
				acc.append(key, `${value}`);
			} else {
				acc.append(...curr);
			}

			return acc;

		}, new FormData());
	}

	return {
		arrToOptionList,
		cleanObj,
		objToFormData,
		objToOptionList
	};
}

export default useObjectHelper;